// @/components/layout/default.jsx
import React from "react";

const LayoutDefault = ({ children }) => {
  // Dark mode removed - not used in production
  return (
    <main className="s-platform bg-zinc-50 flex min-h-dvh flex-col p-2">
      <div className="flex grow items-center justify-center p-6 lg:rounded-2xl lg:bg-white lg:p-12 lg:shadow-2xs lg:ring-1 lg:ring-zinc-200">
        <div className="w-full">{children}</div>
      </div>
    </main>
  );
};

export default LayoutDefault;